{
  "Accessibility Menu": "Хандалтын цэс",
  "Reset settings": "Тохиргоог дахин тохируулах",
  "Close": "Хаах",
  "Content Adjustments": "Агуулгын тохируулга",
  "Adjust Font Size": "Фонтын хэмжээг тохируулах",
  "Highlight Title": "Гарчгийг онцлох",
  "Highlight Links": "Холбоосуудыг онцлох",
  "Readable Font": "Уншихад хялбар фонт",
  "Color Adjustments": "Өнгөний тохируулга",
  "Dark Contrast": "Харанхуй ялгарал",
  "Light Contrast": "Гэрэлтэй ялгарал",
  "High Contrast": "Өндөр ялгарал",
  "High Saturation": "Өндөр ханалт",
  "Low Saturation": "Бага ханалт",
  "Monochrome": "Нэг өнгө",
  "Contrast": "Контраст",
  "Invert Colors": "Өнгийг урвуулах",
  "Tools": "Хэрэгслүүд",
  "Reading Guide": "Унших гарын авлага",
  "Stop Animations": "Анимацийг зогсоох",
  "Big Cursor": "Том курсор",
  "Increase Font Size": "Фонтын хэмжээг нэмэгдүүлэх",
  "Decrease Font Size": "Фонтын хэмжээг багасгах",
  "Letter Spacing": "Үсгийн хоорондын зай",
  "Line Height": "Мөрийн өндөр",
  "Font Weight": "Фонтын жин",
  "Dyslexia Font": "Дислекси фонт",
  "Language": "Хэл",
  "Open Accessibility Menu": "Хандалтын цэсийг нээх",
  "Widget Settings": "Виджетийн тохиргоо",
  "Widget Position": "Виджетийн байрлал",
  "Top Left": "Дээд зүүн",
  "Top Center": "Дээд төв",
  "Top Right": "Дээд баруун",
  "Center Left": "Төвийн зүүн",
  "Center Right": "Төвийн баруун",
  "Bottom Left": "Доод зүүн",
  "Bottom Center": "Доод төв",
  "Bottom Right": "Доод баруун",
  "Screen Reader": "Дэлгэц уншигч",
  "Voice Navigation": "Дуугаар удирдах",
  "Custom Color": "Өөрийн өнгө",
  "Change the site's colors": "Сайтын өнгийг өөрчлөх",
  "Backgrounds": "Дэвсгэрүүд",
  "Headings": "Гарчигууд",
  "Contents": "Агуулга",
  "Reset colors": "Өнгийг дахин тохируулах",
  "Image Desaturation": "Зургийн өнгө бууруулах",
  "Search languages": "Хэл хайх",
  "No languages found": "Хэл олдсонгүй",
  "Accessibility Profiles": "Хүртээмжийн профайл",
  "Motor Impaired": "Хөдөлгөөний бэрхшээлтэй",
  "Big cursor, voice navigation, and no animations.": "Том курсор, дуу хоолойгоор удирдах ба хөдөлгөөнт зураггүй.",
  "Blind": "Хараагүй",
  "Screen reader helpers with higher contrast.": "Өндөр контрасттай дэлгэц уншигчийн туслахууд.",
  "Color Blind": "Өнгө ялгах бэрхшээл",
  "High contrast palette with desaturated media.": "Өндөр контрасттай палитр ба өнгө багасгасан медиа.",
  "Dyslexia": "Дислекси",
  "Friendly font, extra spacing, stronger weight.": "Уншихад хялбар фонт, илүү зай завсар, бүдүүн шрифт.",
  "Low vision": "Бага хараа",
  "Dark contrast and 130% magnification.": "Хар бараан контраст ба 130% томруулалт.",
  "Cognitive & Learning": "Танин мэдэхүй ба суралцах",
  "Highlights key sections and enables voice help.": "Гол хэсгүүдийг тодруулж, дуу хоолойн тусламжийг идэвхжүүлнэ.",
  "Seizure & Epileptic": "Таталт ба эпилепси",
  "Stops animations and desaturates imagery.": "Хөдөлгөөнт зургуудыг зогсоож, өнгийг нь бууруулна.",
  "ADHD": "СААНХ",
  "Reading guide, highlighted links, calmer palette.": "Унших гарын авлага, тодруулсан холбоос, тайван өнгө.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
